import i18n from '@/i18n'

/** Numbers follow the interface language (1,338 in English, 1 338 in Swedish), not the browser's. */
export const formatNumber = (n: number) => n.toLocaleString(i18n.resolvedLanguage)

export function formatMoney(value: number | string | null | undefined, currency = 'SEK') {
  if (value === null || value === undefined || value === '') return '—'
  const n = typeof value === 'number' ? value : Number(value)
  if (Number.isNaN(n)) return String(value)
  try {
    return new Intl.NumberFormat(i18n.resolvedLanguage, { style: 'currency', currency, maximumFractionDigits: 0 }).format(n)
  } catch {
    return `${formatNumber(n)} ${currency}`
  }
}

export function currencySymbol(currency = 'SEK') {
  try {
    const parts = new Intl.NumberFormat(i18n.resolvedLanguage, { style: 'currency', currency }).formatToParts(0)
    return parts.find((p) => p.type === 'currency')?.value ?? currency
  } catch {
    return currency
  }
}

/** The team's own date pattern (team.date_time_format, e.g. "DD/MM/YYYY HH:mm:ss"), as in v1. */
export function formatTeamDate(value: string | Date | null | undefined, pattern = 'MM/DD/YYYY HH:mm') {
  if (!value) return '—'
  const d = value instanceof Date ? value : new Date(value)
  if (Number.isNaN(d.getTime())) return String(value)
  const pad = (n: number) => String(n).padStart(2, '0')
  return pattern
    .replace(/YYYY/g, String(d.getFullYear()))
    .replace(/HH/g, pad(d.getHours()))
    .replace(/MM/g, pad(d.getMonth() + 1))
    .replace(/DD/g, pad(d.getDate()))
    .replace(/ss/g, pad(d.getSeconds()))
    .replace(/mm/g, pad(d.getMinutes()))
}
